export const imageParentData = {
    photoThumbGuid: 'photoGuid',
    photoVersion: 'photoVersion',
    photoOriginGuid: 'photoGuidOrigin',
} as const;

export type TImageParentData = (typeof imageParentData)[keyof typeof imageParentData];

export interface IImageParentData {
    [imageParentData.photoThumbGuid]: string | null;
    // Cache-bust-token (modifiedOn van de hoofdfoto-variant): zorgt dat de hoofdfoto-box na een
    // in-place annotatie/vervang de verse afbeelding toont i.p.v. de gecachte oude.
    [imageParentData.photoVersion]: string | null;
    // Origin (volledige) guid van de hoofdfoto — photoGuid is de thumb-variant (weergave in de
    // hoofdfoto-box); deze guid is nodig om naar ImageDetailsComponent te navigeren (key-route-param).
    [imageParentData.photoOriginGuid]: string | null;
}
